import React from "react";
import PopularProduct from "../../components/PopularProduct";

const PopularProductPage = () => {
  return (
      <PopularProduct />
  );
};

export default PopularProductPage;